import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import { useHistory } from 'react-router'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({})
  const [getErros, setErros] = useState([])
  const [getLoading, setLoading] = useState(true)

  const dispatch = useDispatch()

  const handleInputChange = (event) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const getInfoForForm = async () => {
    try {
      const findAncoraLoja = await api.get(`AncorasLojasCodigos/ConsultarId?id=${id}`)
      setInputs(findAncoraLoja.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas-codigos'))

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Alterar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()
      setLoading(true)
      try {
        delete inputs.dataRegistro

        const response = await api.put('AncorasLojasCodigos', { ...inputs, dataRegistro: undefined })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({
            ...inputs,
            dataAtualizacao: response.data.resposta.dataAtualizacao
          })

          toast.success('Loja código registrado com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []

            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)

              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })

            setErros(errosArray)
          } else {
            toast.error('Não foi possível alterar a nova loja código!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getErros={getErros}
    setErros={setErros}
    onSubmit={handleSubmit}
  />
}

export default Register
